import styled from 'styled-components';

const Wrapper = styled.div`
  margin: auto;
  width: 30px;
  height: 30px;
  position: relative;
`;

export default Wrapper;
